var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.60156 9.6C6.60156 9.26863 6.87019 9 7.20156 9V9C7.53293 9 7.80156 9.26863 7.80156 9.6V12.4C7.80156 12.7314 7.53293 13 7.20156 13V13C6.87019 13 6.60156 12.7314 6.60156 12.4V9.6Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.40234 9.60078C6.40234 9.15895 6.76052 8.80078 7.20234 8.80078C7.64417 8.80078 8.00234 9.15895 8.00234 9.60078V12.4008C8.00234 12.8426 7.64417 13.2008 7.20234 13.2008C6.76052 13.2008 6.40234 12.8426 6.40234 12.4008V9.60078ZM7.20234 9.20078C6.98143 9.20078 6.80234 9.37987 6.80234 9.60078V12.4008C6.80234 12.6217 6.98143 12.8008 7.20234 12.8008C7.42326 12.8008 7.60234 12.6217 7.60234 12.4008V9.60078C7.60234 9.37987 7.42326 9.20078 7.20234 9.20078Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5771 12C10.8559 12 11.082 12.2261 11.082 12.505V12.505C11.082 12.7839 10.8559 13.01 10.5771 13.01L3.5074 13.01C3.22851 13.01 3.00242 12.7839 3.00242 12.505V12.505C3.00242 12.2261 3.22851 12 3.5074 12L10.5771 12Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5763 11.8008C10.9656 11.8008 11.2812 12.1164 11.2812 12.5058C11.2812 12.8951 10.9656 13.2107 10.5763 13.2107L3.50662 13.2107C3.11727 13.2107 2.80164 12.8951 2.80164 12.5058C2.80164 12.1164 3.11727 11.8008 3.50662 11.8008L10.5763 11.8008ZM10.8812 12.5058C10.8812 12.3373 10.7447 12.2008 10.5763 12.2008L3.50662 12.2008C3.33818 12.2008 3.20164 12.3373 3.20164 12.5058C3.20164 12.6742 3.33818 12.8107 3.50662 12.8107L10.5763 12.8107C10.7447 12.8107 10.8812 12.6742 10.8812 12.5058Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H12.2239C13.1904 0.25 13.9739 1.0335 13.9739 2V8.1493C13.9739 9.1158 13.1904 9.8993 12.2239 9.8993H2C1.0335 9.8993 0.25 9.1158 0.25 8.1493V2ZM2 1.75C1.86193 1.75 1.75 1.86193 1.75 2V8.1493C1.75 8.28737 1.86193 8.3993 2 8.3993H12.2239C12.362 8.3993 12.4739 8.28737 12.4739 8.1493V2C12.4739 1.86193 12.362 1.75 12.2239 1.75H2Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebIcon);
export default __webpack_public_path__ + "static/media/web-icon.08d22bf2d68bff8fbdc087183429f9c0.svg";
export { ForwardRef as ReactComponent };